import React from 'react';

import { Icon } from 'ui/component';
import { CaseTabContentContainer } from '../case-tab-content-container';
import classNames from './EABD2CaseChallengesTabContent.module.scss';
import { StyleUtil } from 'ui/util';

type CaseChallengeDefaultItemIcon = 'clock' | 'reload' | 'avatarLarger' | 'globe' | 'node' | 'accelerometer' | 'invoice' | 'phone';

export interface CaseChallengeDefaultItemModel
  extends Readonly<{
    type: 'default';
    icon: CaseChallengeDefaultItemIcon;
    text: string;
  }> {}

export interface CaseChallengeSpacerItemModel
  extends Readonly<{
    type: 'spacer';
  }> {}

export type CaseChallengeItemModel = CaseChallengeDefaultItemModel | CaseChallengeSpacerItemModel;

export interface CaseChallengesTabContentProps
  extends Readonly<{
    items: CaseChallengeItemModel[];
  }> {}

export const CaseChallengesTabContent = React.memo<CaseChallengesTabContentProps>((props) => {
  const { items } = props;

  const RenderItemCallback = React.useCallback((item: CaseChallengeItemModel, index: number) => {
    if (item.type === 'spacer') {
      return <div key={`$spacer-${index}`} className={StyleUtil.mergeClassNames([classNames.item, classNames.spacer])} />;
    }

    return (
      <div key={`${item.text}-${index}`} className={classNames.item}>
        <div className={classNames.iconWrapper}>
          <div className={classNames.icon}>
            <Icon type={item.icon} />
          </div>
        </div>
        <div className={classNames.textWrapper}>
          <p className={classNames.text}>{item.text}</p>
        </div>
      </div>
    );
  }, []);

  return <CaseTabContentContainer>{items.map(RenderItemCallback)}</CaseTabContentContainer>;
});
